export default __webpack_public_path__ + "static/pragicts-digital-outreach-animal-husbandry-agriculture-89d2a557a6ef4833946fbea537294e7b.jpg";